var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ColorHex } from '@axafr-btc-ds/colors';
import { FieldState } from '@axafr-btc-ds/form-validation';
import { IconClear, IconSize } from '@axafr-btc-ds/icons';
import { Typography } from '@axafr-btc-ds/typography';
import { cx } from '@emotion/css';
import React from 'react';
import { cssFormErrorMessage, cssIcon } from './css';
export var AbstractFormErrorMessage = function (_a) {
    var fieldState = _a.fieldState, className = _a.className, errorMessage = _a.errorMessage, id = _a.id, props = __rest(_a, ["fieldState", "className", "errorMessage", "id"]);
    return (React.createElement(Typography, __assign({ variant: 'label2', id: id, className: cx(cssFormErrorMessage(fieldState === FieldState.IS_ERROR), className) }, props, { color: ColorHex.shytomato }),
        React.createElement(IconClear, { className: cssIcon, color: ColorHex.shytomato, size: IconSize.xs }),
        errorMessage));
};
